<ion-content>
  <div #cameraElm id="cameraPreview" class="m-camera"></div>
  <div *ngIf="CAMERA_MODEL.state === 'GALLERY'">
    <ion-row>
      <ion-col *ngIf="CAMERA_MODEL.bucketInfo.files.length === 0" [size]="12"> Please take photo of defect </ion-col>
      <ion-col *ngIf="CAMERA_MODEL.bucketInfo.files.length === CAMERA_MODEL.bucketInfo.limit" [size]="12">
        Limt Reached please remove photos to add new one
      </ion-col>
      <ion-col [size]="4" *ngFor="let file of CAMERA_MODEL.bucketInfo.files; let idx = index">
        <ion-card>
          <img [src]="file.publicPath" />
          <ion-card-content>
            <ion-row>
              <ion-col>
                <ion-button (click)="previewFile(idx)"> Preview </ion-button>
              </ion-col>
              <ion-col>
                <ion-button (click)="removeFile(file)"> Remove </ion-button>
              </ion-col>
            </ion-row>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </div>
  <div *ngIf="CAMERA_MODEL.state === 'PREVIEW'" class="m-camera__preview">
    <div class="m-camera__preview">
      <img
        class="m-camera__preview"
        *ngIf="CAMERA_MODEL.bucketInfo.activeFileIndex >= 0"
        [src]="CAMERA_MODEL.bucketInfo.files[CAMERA_MODEL.bucketInfo.activeFileIndex].publicPath"
      />
    </div>
  </div>
</ion-content>
<ion-footer class="m-camera__footer">
  <ion-row class="ion-justify-content-center ion-align-items-center">
    <ion-col class="ion-text-left">
      <ion-icon name="images" *ngIf="CAMERA_MODEL.state !== 'GALLERY'" (click)="openGallery()"></ion-icon>
    </ion-col>
    <ion-col class="ion-text-center">
      <ion-icon
        name="ellipse"
        class="ion-activatable ripple-parent circle"
        [ngClass]="{
          'm-camera--disable': CAMERA_MODEL.bucketInfo.hasLimitReached
        }"
        *ngIf="CAMERA_MODEL.state === 'LOADED'"
        (click)="!CAMERA_MODEL.bucketInfo.hasLimitReached && captureImage()"
      >
        <ion-ripple-effect></ion-ripple-effect>
      </ion-icon>

      <ion-icon
        name="camera"
        class="ion-activatable ripple-parent circle"
        [ngClass]="{
          'm-camera--disable': CAMERA_MODEL.bucketInfo.hasLimitReached
        }"
        *ngIf="CAMERA_MODEL.state === 'GALLERY' || CAMERA_MODEL.state === 'PREVIEW'"
        (click)="!CAMERA_MODEL.bucketInfo.hasLimitReached && toggleCamera()"
      >
        <ion-ripple-effect></ion-ripple-effect>
      </ion-icon>
    </ion-col>
    <ion-col class="ion-text-right">
      <ion-button (click)="done()">Done</ion-button>
    </ion-col>
  </ion-row>
</ion-footer>
